import { render, staticRenderFns } from "./ModalContentDeleteInfrastructureContractor.vue?vue&type=template&id=222f7e10&scoped=true&"
import script from "./ModalContentDeleteInfrastructureContractor.vue?vue&type=script&lang=js&"
export * from "./ModalContentDeleteInfrastructureContractor.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentDeleteInfrastructureContractor.vue?vue&type=style&index=0&id=222f7e10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222f7e10",
  null
  
)

export default component.exports